import * as React from "react"
import { graphql, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { getShopifyImage } from "gatsby-source-shopify"
import { formatPrice } from "../utils/format-price"
import slugify from "@sindresorhus/slugify"
import {
  productHeadingStyle,
  productDetailsStyle,
  productVendorStyle,
  productPrice,
  circle
} from "./product-card.module.css"

export function CollectionProductCard({ product, collectionTitle, eager }) {
  const {
    title,
    handle,
    priceRangeV2,
    images: [firstImage],
    vendor,
    storefrontImages,
  } = product

  console.log(collectionTitle)

  const price = formatPrice(
    priceRangeV2.minVariantPrice.currencyCode,
    priceRangeV2.minVariantPrice.amount
  )

  const defaultImageHeight = 200
  const defaultImageWidth = 200
  let storefrontImageData = {}
  if (storefrontImages) {
    const storefrontImage = storefrontImages.edges[0].node
    try {
      storefrontImageData = getShopifyImage({
        image: storefrontImage,
        layout: "fixed",
        width: defaultImageWidth,
        height: defaultImageHeight,
      })
    } catch (e) {
      console.error(e)
    }
  }

  const hasImage = firstImage || Object.getOwnPropertyNames(storefrontImageData || {}).length

  return (
    <Link
      className="productCardStyle"
      to={`/collections/${slugify(collectionTitle)}/${handle}`}
      aria-label={`View ${title} product page`}
    >
      <div className={productVendorStyle}>{vendor}</div>
      {hasImage
        ? (
          <div data-name="product-image-box">
            <GatsbyImage
              alt={firstImage?.altText ?? title}
              image={firstImage?.gatsbyImageData ?? storefrontImageData}
              loading={eager ? "eager" : "lazy"}
              imgStyle={{borderRadius: "0"}}
            />
          </div>
        ) : (
          <div style={{ height: defaultImageHeight, width: defaultImageWidth }} />
        )
      }
      <div className={productDetailsStyle}>
        <h2 as="h2" className={productHeadingStyle}>
          {title}
        </h2>
        <div className={productPrice}>
          <div className={circle}></div>
          {price}
          </div>
      </div>
    </Link>
  )
}

export const query = graphql`
  fragment CollectionProductCard on ShopifyCollection{
    title
    products {
      id
    title
    handle
    images {
      id
      altText
      gatsbyImageData(aspectRatio: 1, width: 640)
    }
    priceRangeV2 {
      minVariantPrice {
        amount
        currencyCode
      }
    }
    vendor
    }
  }
`